// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ProjectActualSavingsContainer_wrap__2bO4l","table":"ProjectActualSavingsContainer_table__24jpm"};